import { EUiStates } from "@constants/enum";
import { ReactElement } from "react";
import { Modal } from "reactstrap";
import styles from "./ModalUploadProgress.module.scss";
import { EModalUploadProgress } from "@enums/modalUploadProgress";
import { getModalUpload } from "@helpers/modalUploadProgress.helper";
import { formatBytes } from "@helpers/gcp.helper";

interface IModalUploadProgress {
  modalStatus: boolean;
  modalType: EUiStates;
  status: EModalUploadProgress;
  uploadedFiles: number;
  totalFiles: number;
  uploadedSize: number;
  totalSize: number;
}

const ModalUploadProgress = ({
  modalStatus,
  modalType,
  status,
  uploadedFiles,
  totalFiles,
  uploadedSize,
  totalSize,
}: IModalUploadProgress): ReactElement => {
  const { title, text } = getModalUpload(status);
  const progressBarPercentage = (uploadedSize / totalSize) * 100;

  return (
    <Modal
      isOpen={modalStatus}
      className={`modal-dialog--${modalType} ${styles.modalContainer}`}
    >
      <div className={styles.modalBody}>
        <div className="modal__header">
          <h4 className="text-modal modal__title">{title}</h4>
        </div>

        <div className="modal__body">
          <div>{text}</div>
        </div>

        <div className={styles.progressBar}>
          <div className={styles.textInfo}>
            <div className="">
              <span className="">{progressBarPercentage.toFixed(2)}%</span> |{" "}
              <span className="">{formatBytes(uploadedSize)}</span> /{" "}
              <span className="">{formatBytes(totalSize)}</span>
            </div>
            <div>
              <span className="">{uploadedFiles}</span> of{" "}
              <span className="">{totalFiles}</span> files uploaded
            </div>
          </div>
          <div className={styles.background}>
            <div
              className={styles.progress}
              style={{ width: `${progressBarPercentage}%` }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalUploadProgress;
